import 'twin.macro';
import React from 'react';
import { EmptyButton } from '../EmptyButton';
import { School } from '@teetsh/app/src/types/school';
import { useTranslation } from 'react-i18next';

export interface LivretSchoolInfo {
  academy?: string;
  name: string;
  address?: string;
  phone?: string;
  email?: string;
}

interface Props {
  school: LivretSchoolInfo;
  onUpdateSchoolField?: (field: keyof School, value: string) => void;
  readonly?: boolean;
}

export function SchoolInfo(props: Props) {
  const { onUpdateSchoolField, school, readonly } = props;
  const { t } = useTranslation(['carnet', 'common']);
  const { academy, address, email, phone, name } = school;

  if (readonly) {
    return (
      <div>
        {academy && (
          <div>{t('carnet:livret.academyOf', { name: academy })}</div>
        )}
        {name && <div tw="font-semibold">{name}</div>}
        {address && <div>{address}</div>}
        {phone && <div>{phone}</div>}
        {email && <div>{email}</div>}
      </div>
    );
  }

  return (
    <div>
      <div>
        {academy && (
          <div tw="ml-1">{t('carnet:livret.academyOf', { name: academy })}</div>
        )}
        <EmptyButton
          placeholder={t('carnet:livret.schoolNamePlaceholder')}
          value={name}
          onChange={v => onUpdateSchoolField && onUpdateSchoolField('name', v)}
          tw="font-semibold"
        />
        <EmptyButton
          placeholder={t('carnet:livret.addressPlaceholder')}
          onChange={v =>
            onUpdateSchoolField && onUpdateSchoolField('address', v)
          }
          value={address}
        />
        <EmptyButton
          onChange={v => onUpdateSchoolField && onUpdateSchoolField('phone', v)}
          placeholder={t('carnet:livret.phonePlaceholder')}
          value={phone}
        />
        <div>
          <EmptyButton
            onChange={v =>
              onUpdateSchoolField && onUpdateSchoolField('email', v)
            }
            placeholder={t('carnet:livret.emailPlaceholder')}
            value={email}
          />
        </div>
      </div>
    </div>
  );
}
